import { HelpContent } from "@/components/help/HelpContent";
import { useSetBreadcrumbs } from "@/components/shared/breadcrumbs";
import { PageHeader } from "@/components/shared/page-header";

export function HelpPage() {
  useSetBreadcrumbs([{ label: "My Workspace" }, { label: "Help" }]);

  return (
    <div className="space-y-6">
      <PageHeader
        eyebrow="My Workspace"
        title="Help"
        description="A guide to navigating Enable and making the most of it."
      />
      <HelpContent />
    </div>
  );
}
